import { __spreadArray, __read } from '../../external/tslib/tslib.es6.mjs.js';
import { useRef, useCallback } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function useDebounce(callback, delay) {
    var functionTimeoutHandler = useRef(null);
    var debouncedFunction = useRef(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = useCallback(function () {
        if (functionTimeoutHandler.current) {
            clearTimeout(functionTimeoutHandler.current);
            functionTimeoutHandler.current = null;
        }
    }, []);
    var debouncedCallback = useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        cancelDebouncedCallback();
        functionTimeoutHandler.current = window.setTimeout(function () {
            debouncedFunction.current.apply(debouncedFunction, __spreadArray([], __read(args), false));
        }, delay);
    }, [delay, cancelDebouncedCallback]);
    return [debouncedCallback];
}

export { useDebounce };
